import { Theme, makeStyles, createStyles } from '@material-ui/core';
import React from 'react';
import { TasksSummaryPage } from '../../components/LoadComponentAsync';
import { IAutoCompleteItem } from '../../typings/autoComplete';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        // The bordered/rounded/shadowed box (and its padding) now lives in
        // MatterDetailsTabList.tsx's own `contentBox` — shared by every tab — so this only
        // needs to keep relaying a real bounded height down to TasksSummaryPage.
        root: {
            display: 'flex',
            flex: 1,
            minHeight: 0,
        },
    })
);

interface TasksTabProps {
    matter: {
        id: number;
        matterGuid: string;
        title: string;
        fileNumber: string;
        client: string;
    };
}

export const TasksTab: React.FC<TasksTabProps> = (props) => {

    const classes = useStyles();

    const { matter } = props;

    // tslint:disable-next-line: no-any
    const matterSelected: IAutoCompleteItem | any = {
        label: matter.fileNumber + ' (' + matter.title + ')',
        value: matter.matterGuid,                       
        fileNumber: matter.fileNumber,
        title: matter.title,
        client: matter.client,
        id: matter.id  
    };

    return (
        <div className={classes.root}>
            <TasksSummaryPage
                matterSelected={matterSelected}
            />
        </div>
    );
};